import { InputMask } from './input-masks'

export class PhoneNumberInputMask implements InputMask {
    mask(val: string) {
        if (val === undefined) {
            return ''
        }

        if (val.length < 4) {
            return val
        } else if (val.length < 7) {
            return `${val.slice(0, 3)}-${val.slice(3, 6)}`
        } else {
            return `${val.slice(0, 3)}-${val.slice(3, 6)}-${val.slice(6, 10)}`
        }
    }

    unmask(val: string) {
        if (val === undefined) {
            return ''
        }

        return val.replace(new RegExp('-', 'g'), '')
    }
}
